import React, { useState, useEffect } from "react";

const MockTestResult = ({ finalResult }) => {

  const [animateScore, setAnimateScore] = useState(0);

  const containerStyle = {
    minHeight: "100vh",
    // background: "#dadada",
    padding: "40px 20px",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const contentWrapperStyle = {
    maxWidth: "900px",
    margin: "0 auto",
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "40px",
  };

  const titleStyle = {
    fontSize: "36px",
    fontWeight: "700",
    color: "#333333",
    marginBottom: "12px",
    textShadow: "0 2px 10px rgba(0,0,0,0.1)",
  };

  const subtitleStyle = {
    fontSize: "16px",
    color: "#2a2a2a",
    fontWeight: "400",
  };

  const mainCardStyle = {
    background: "#ffffff",
    borderRadius: "24px",
    padding: "48px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    marginBottom: "24px",
  };

  const scoreCircleContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "40px",
    position: "relative",
  };

  const scoreCircleStyle = {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    background: " #006bff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 10px 40px rgba(102, 126, 234, 0.4)",
    position: "relative",
  };

  const scoreValueStyle = {
    fontSize: "56px",
    fontWeight: "800",
    color: "#ffffff",
    lineHeight: "1",
  };

  const scoreMaxStyle = {
    fontSize: "20px",
    color: "rgba(255,255,255,0.8)",
    marginTop: "8px",
  };

  const statusBadgeStyle = {
    background:
      finalResult.score >= 70 ? "#10b981" : finalResult.score >= 50 ? "#f59e0b" : "#ef4444",
    color: "#ffffff",
    padding: "8px 24px",
    borderRadius: "24px",
    fontSize: "14px",
    fontWeight: "600",
    display: "inline-block",
    marginBottom: "32px",
    textTransform: "uppercase",
    letterSpacing: "1px",
  };

  const statsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    marginBottom: "40px",
  };

  const statCardStyle = {
    background: "linear-gradient(135deg, #f6f8fb 0%, #ffffff 100%)",
    borderRadius: "16px",
    padding: "24px",
    border: "2px solid #e2e8f0",
    transition: "all 0.3s ease",
  };

  const statLabelStyle = {
    fontSize: "13px",
    color: "#718096",
    textTransform: "uppercase",
    letterSpacing: "1px",
    fontWeight: "600",
    marginBottom: "12px",
  };

  const statValueStyle = {
    fontSize: "32px",
    fontWeight: "700",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  };

  const sectionTitleStyle = {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
  };

  const performanceBarContainerStyle = {
    marginBottom: "40px",
  };

  const performanceItemStyle = {
    marginBottom: "20px",
  };

  const performanceLabelStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#4a5568",
  };

  const progressBarBgStyle = {
    height: "12px",
    background: "#e2e8f0",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
  };

  const getProgressBarStyle = (percentage) => ({
    height: "100%",
    background:
      percentage >= 75
        ? "linear-gradient(90deg, #10b981 0%, #059669 100%)"
        : percentage >= 50
          ? "linear-gradient(90deg, #f59e0b 0%, #d97706 100%)"
          : "linear-gradient(90deg, #ef4444 0%, #dc2626 100%)",
    width: `${percentage}%`,
    borderRadius: "10px",
    transition: "width 1.5s ease-out",
  });

  const bottomCardsStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "24px",
  };

  const infoCardStyle = {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "32px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  };

  const iconWrapperStyle = (bgColor) => ({
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    background: bgColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  });

  const cardTitleStyle = {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "8px",
  };

  const cardDescStyle = {
    fontSize: "14px",
    color: "#718096",
    lineHeight: "1.6",
  };

  const buttonStyle = {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#ffffff",
    border: "none",
    padding: "16px 32px",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    transition: "all 0.3s ease",
    marginRight: "12px",
    marginTop: "32px",
  };

  const secondaryButtonStyle = {
    background: "#ffffff",
    color: "#667eea",
    border: "2px solid #667eea",
    padding: "16px 32px",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginTop: "32px",
  };



  return (
    <div style={containerStyle}>
      <div style={contentWrapperStyle}>
        <div style={headerStyle}>
          <h1 style={titleStyle}>🎉 Test Completed!</h1>
          <p style={subtitleStyle}>Here's your detailed performance report</p>
        </div>

        <div style={mainCardStyle}>
          <div style={{ textAlign: "center" }}>
            <div style={statusBadgeStyle}>
              {finalResult.score >= 70
                ? "✓ Passed"
                : finalResult.score >= 50
                  ? "⚠ Average"
                  : "✗ Need Improvement"}
            </div>
          </div>

          <div style={scoreCircleContainerStyle}>
            <div style={scoreCircleStyle}>
              <div style={scoreValueStyle}>{animateScore}</div>
              <div style={scoreMaxStyle}>out of 100</div>
            </div>
          </div>

          <div style={statsGridStyle}>
            <div style={statCardStyle}>
              <div style={statLabelStyle}>Correct</div>
              <div style={statValueStyle}>{finalResult.correct} / {finalResult.correct + finalResult.incorrect + finalResult.unanswered}</div>
            </div>
            <div style={statCardStyle}>
              <div style={statLabelStyle}>Accuracy</div>
              <div style={statValueStyle}>{finalResult.accuracy}%</div>
            </div>
            <div style={statCardStyle}>
              <div style={statLabelStyle}>Time Taken</div>
              <div style={statValueStyle}>90 min</div>
            </div>
            <div style={statCardStyle}>
              <div style={statLabelStyle}>Percentile</div>
              <div style={statValueStyle}>{finalResult.percentile}th</div>
            </div>
          </div>

          <div style={performanceBarContainerStyle}>
            <h3 style={sectionTitleStyle}>📊 Subject-wise Performance</h3>
            {
              Object.keys(finalResult.subjectWise).map(item => (
                <div style={performanceItemStyle}>
                  <div style={performanceLabelStyle}>
                    <span>{item}</span>
                    <span>{finalResult.subjectWise[item].percentage}%</span>
                  </div>
                  <div style={progressBarBgStyle}>
                    <div style={getProgressBarStyle(finalResult.subjectWise[item].percentage)}></div>
                  </div>
                </div>
              ))
            }
          </div>

          {/* <div style={{ textAlign: "center" }}>
            <button style={buttonStyle}>View Detailed Solutions</button>
            <button style={secondaryButtonStyle}>Download Report</button>
          </div> */}
        </div>

        <div style={bottomCardsStyle}>
          <div style={infoCardStyle}>
            <div
              style={iconWrapperStyle(
                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
              )}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <h4 style={cardTitleStyle}>Strong Areas</h4>
            {
              finalResult.strengths.map(item => (
                <p style={cardDescStyle}>
                  {item}
                </p>
              ))
            }
          </div>

          <div style={infoCardStyle}>
            <div
              style={iconWrapperStyle(
                "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
              )}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2"
              >
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <h4 style={cardTitleStyle}>Areas to Improve</h4>
            {
              finalResult.weaknesses.map(item => (
                <p style={cardDescStyle}>
                  {item}
                </p>
              ))
            }
          </div>

          <div style={infoCardStyle}>
            <div
              style={iconWrapperStyle(
                "linear-gradient(135deg, #10b981 0%, #059669 100%)"
              )}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="2"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h4 style={cardTitleStyle}>Next Steps</h4>
            <p style={cardDescStyle}>
              Practice more questions on weak topics and attempt the next level
              mock test to track improvement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockTestResult;
